import { send } from './saveHttp';

/**
 * Hand-written client for the connector-next course-stage endpoint (the
 * generated client is not used for mutations that need If-Match — the HTTP
 * conventions live in `saveHttp.ts`, shared with the save clients).
 *
 * The stage and the stages marked done travel together in one request,
 * because moving the stage and marking one finished are separate statements
 * the caller makes explicitly: the server stores what it is sent and infers
 * neither from the other.
 */
export async function postCourseStage(
    patientId: string,
    stage: string,
    done: readonly string[],
    ifMatch: string
): Promise<void> {
    await send(
        `/api/patients/${patientId}/course-stage`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ stage, done }),
        },
        ifMatch
    );
}
